import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { postRequest } from '~services';

type UseSearchOptions = {
  path: string;
  queryKey: string[];
  bodyRequest?: object;
};

/**
 *
 * @param path example: api/venue-type/list
 * @param queryKey example: [QUERY_KEY.GET_LIST_VENUE_TYPE]
 * @returns
 */
export const useSearchOptions = ({
  path,
  queryKey,
  bodyRequest,
}: UseSearchOptions) => {
  const [search, setSearch] = useState<string>('');

  const onSearch = (searchString: string) => {
    setSearch(searchString);
  };

  const data = useQuery([...queryKey, search, bodyRequest], () =>
    postRequest({
      path,
      data: { page: 0, size: 20, name: search, ...bodyRequest },
    }),
  );

  return {
    onSearch,
    options: data.data?.data?.data || [],
  };
};
